import { combineReducers } from 'redux';
import print from './print.reducer';

const reportReducer = combineReducers({
  print,
});

export default reportReducer;
